function getAllUrlParams(url) {

    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');

            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {

                // create key if it doesn't exist
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    // otherwise add the value to the end of the array
                    obj[key].push(paramValue);
                }
            } else {
                // we're dealing with a string
                if (!obj[paramName]) {
                    // if it doesn't exist, create property
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string'){
                    // if property does exist and it's a string, convert it to an array
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    // otherwise add the property
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
}

class EcommerceForm {
    constructor() {
        this.buttonList = document.querySelectorAll('.js-ecommerce-submit')
        this.filterList = document.querySelectorAll('.js-ecommerce-filter a');
        this.mobileFilterList = document.querySelectorAll('.js-ecommerce-filter select');
        this.ecommerceForm = document.querySelector('.js-ecommerce-form');
        this.numOfferField  = document.querySelector('.js-ecommerce-numOffer');
        this.activityIdField  = document.querySelector('.js-ecommerce-activityId');
        this.newMemberField  = document.querySelector('.js-ecommerce-newMember');
        this.products = document.querySelectorAll(('[data-ecommerce]'));
        this.mobileForm = document.querySelector('.js-ecommerce-form-mobile');
        this.promoProducts = window.promoProductIds || [];
        this.impressionProducts = window.impressionProductIds || [];
        this.hiddenProducts = {};
    }

    init() {
        if (this.buttonList.length > 0 ) {
            this.updateButtonLinks();
            this.bindEvents();
        }

        if (this.products.length) {
            this.trackImpressions();
            this.trackEecImpressions();
        }
    }

    bindEvents() {
        this.buttonList.forEach(button => {
            button.addEventListener('click', this.handleClick.bind(this));
        });

        const _this = this;
        document.addEventListener('click', event => {
            if (event.target.classList.contains('js-ecommerce-submit') && event.target.classList.contains('js-skip-url')) {
                this.handleClick(event);
            }
        });

        if (this.filterList.length) {
            const _this = this;
            document.querySelectorAll('.pimcore_area_product-configurator').forEach(configurator => this.updateFilters(configurator.closest('section')));

            this.filterList.forEach(button => {
                button.addEventListener('click', this.handleFilter.bind(this));
            })
        }

        if (this.mobileFilterList.length) {
            const _this = this;
            document.querySelectorAll('.pimcore_area_product-configurator').forEach(configurator => this.updateFilters(configurator.closest('section')));

            this.mobileFilterList.forEach(select => {
                select.addEventListener('change', function() {
                    let option = select.querySelector('option[value="' + select.value + '"]');

                    let selector = '.js-product.button';
                    selector  += '[data-filter-key="' + option.dataset.filterKey + '"]';
                    selector  += '[data-filter-value="' + option.dataset.filterValue + '"]';

                    let button = select.closest('.js-ecommerce-filter').querySelector(selector);

                    if (button) {
                        button.dispatchEvent(new Event('click'));
                    }
                });
            })
        }

        if (this.mobileForm) {
            this.mobileForm.addEventListener('change', event => {
                this.handleFormChange(event.currentTarget);
            });
            this.handleFormChange(this.mobileForm);
        }
    }

    handleFormChange(form) {
        const formData = new FormData(form);
        const productContainer = document.querySelector('.js-ecommerce-form-mobile-products')
        let selector = '.js-ecommerce-form-mobile-products ';

        productContainer.querySelectorAll('[data-ecommerce]').forEach(el => el.parentElement.parentElement.classList.add('is-hidden'));

        selector  += '[data-ecommerce-productvariation="' + formData.get('productVariation') + '"]';

        if (formData.get('productArea') !== null) {
            selector  += '[data-ecommerce-productarea="' + formData.get('productArea') + '"]';
        }

        selector  += '[data-ecommerce-isplus="' + (formData.get('isPlus')  === 'true' ? '1' : '0') + '"]';
        selector  += '[data-ecommerce-isvrs="' + (formData.get('isVrs')  === 'true' ? '1' : '0') + '"]';

        const element = document.querySelector(selector);

        if (element) {
            element.parentElement.parentElement.classList.remove('is-hidden')
        }
    }

    handleClick(event) {
        const element = event.target;
        const productContainer = element.closest('[data-ecommerce]');

        if (productContainer) {
            const id = productContainer.dataset.ecommerceId;
            const numOffer = productContainer.dataset.ecommerceNumoffer;
            const newMember = productContainer.dataset.ecommerceNewmember === '1' ? '1' : '0';
            const isYouth =  productContainer.dataset.ecommerceIsyouth;
            const isVrs = productContainer.dataset.ecommerceIsvrs;
            const isEndorsement = productContainer.dataset.ecommerceIsendorsement;
            const activityId = productContainer.dataset.ecommerceActivityid;
            const legacy = productContainer.dataset.ecommerceLegacy;
            const campaignId = productContainer.dataset.ecommerceCampaign;
            const shopPath = productContainer.dataset['ecommerceShoppath' + document.documentElement.lang];

            this.numOfferField.value = numOffer;
            this.newMemberField.value = newMember;
            this.activityIdField.value = activityId;

            this.trackAddToCart(productContainer);

            if (this.promoProducts.indexOf(parseInt(id)) !== -1) {
                this.trackPromotionSelect(productContainer);
            } else {
                this.trackItemSelect(productContainer);
            }
        }
    }

    prepareItem(product) {
        const eecInfo = JSON.parse(product.dataset.eec)[0];
        console.log(eecInfo)
        const trackingInfo = productList[eecInfo.variant] || {};
        let itemVariant = '';
        let productVariant = '';

        if (trackingInfo.coverType === 'PLUS') {
            productVariant = 'Premium';
        } else if (trackingInfo.coverType === 'STD') {
            productVariant = 'Standard';
        } else {
            productVariant = 'N/A';
        }

        // try to find discounted price
        let discountedPrice = 0;
        let discount = 0;
        let priceElement = product.querySelector('.price .is-current');
        if (priceElement) {
            discountedPrice = parseFloat(priceElement.innerText.replace(/[^\d.-]/g, ''));
            if (discountedPrice) {
                discount = trackingInfo.price - discountedPrice;
                discount = Math.round((discount + Number.EPSILON) * 100) / 100;
            }
        }

        if (trackingInfo.id) {
            itemVariant = productVariant + '_' + trackingInfo.familyVariant + '_' + trackingInfo.breakdownVariant + '_' + trackingInfo.coverArea;
            itemVariant = itemVariant.replaceAll('null', 'N/A');
        }

        return {
            "item_id": trackingInfo.id || 0,
            "item_name": trackingInfo.shortName || 'N/A',
            "discount": discount,
            "currency": "CHF",
            "index": 1,
            "item_brand": 'Club',
            "item_category": trackingInfo.category || 'N/A',
            "item_variant": itemVariant,
            "price": trackingInfo.price || 0,
            "quantity": 1,
            "cp_ecom_product_region": trackingInfo.coverArea || 'N/A',
            "cp_ecom_product_club_scope": product.dataset.ecommerceIsyouth === '1' ? 'YOUNG' : (trackingInfo.familyVariant || 'N/A'),
            "cp_ecom_product_club_breakdown_service": trackingInfo.breakdownVariant || 'N/A',
            "cp_ecom_product_name": eecInfo.variant
        }
    }

    trackEecImpressions() {
        let productImpressions = [];
        this.products.forEach(product => {
            if (product.dataset.eec) {
                const trackingInfo = JSON.parse(product.dataset.eec);
                if (trackingInfo.length) {
                    productImpressions = productImpressions.concat(trackingInfo);
                }
            }
        });

        if (productImpressions.length) {

            productImpressions = productImpressions.filter((value, index, self) => self.findIndex( next => ( next.variant === value.variant)) === index);

            let utmParams = getAllUrlParams();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'ecommerceProductImpressions',
                'ecommerce': {
                    'currencyCode': 'CHF',
                    'add': {
                        'actionField': {'list': 'detail'},
                        'impressions': productImpressions
                    }
                }
            });
        }
    }

    trackAddToCart(product) {
        if (product.dataset.eec) {
            let utmParams = getAllUrlParams();
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'ecommerceAddToCart',
                'campaignSource': utmParams.utm_source || '',
                'campaignMedium': utmParams.utm_medium || '',
                'campaignName': utmParams.utm_campaign || '',
                'campaignTerm': utmParams.utm_term || '',
                'campaignContent': utmParams.utm_content || '',
                'ecommerce': {
                    'currencyCode': 'CHF',
                    'add': {
                        'actionField': {'list': 'detail'},
                        'products': JSON.parse(product.dataset.eec)
                    }
                }
            });
        }
    }

    trackImpressions() {
        let itemImpressions = [];
        let promoImpressions = [];

        this.products.forEach(product => {
            if (this.promoProducts.indexOf(parseInt(product.dataset.ecommerceId)) !== -1) {
                promoImpressions.push(product);
            } else {
                itemImpressions.push(product);
            }
        });

        if (promoImpressions.length) {
            promoImpressions.forEach((product) => {
                this.trackPromoImpression(product);
            });
        }

        if (itemImpressions.length) {
            this.trackItemList(itemImpressions);
        }
    }

    trackItemSelect(product) {
        if (product.dataset.eec) {
            const item = this.prepareItem(product);
            let utmParams = getAllUrlParams();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "select_item",
                'campaignSource': utmParams.utm_source || '',
                'campaignMedium': utmParams.utm_medium || '',
                'campaignName': utmParams.utm_campaign || '',
                'campaignTerm': utmParams.utm_term || '',
                'campaignContent': utmParams.utm_content || '',
                "ecommerce": {
                    "items": [
                        item
                    ],
                    "item_list_id": "membership_product_list",
                    "item_list_name": "membership product list"
                },
                "gtm.uniqueEventId": 1
            })
        }
    }

    getCreativeSlot(product) {
        let creativeSlot = '';
        const section = product.closest('section');

        if (section) {
            const heading = section.querySelector('.heading-1, .heading-2, .heading-3, .heading-4');
            if (heading) {
                creativeSlot = heading.innerText;
            }
        }

        return creativeSlot;
    }

    trackPromotionSelect(product) {
        if (product.dataset.eec) {
            const item = this.prepareItem(product);

            let promotionName = window.promotionName;
            let utmParams = getAllUrlParams();

            const heading = product.querySelector('.heading-1, .heading-2, .heading-3, .heading-4');
            if (heading) {
                promotionName = 'Club - ' + window.tcsCampaign + ' - ' + heading.innerText;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "select_promotion",
                'campaignSource': utmParams.utm_source || '',
                'campaignMedium': utmParams.utm_medium || '',
                'campaignName': utmParams.utm_campaign || '',
                'campaignTerm': utmParams.utm_term || '',
                'campaignContent': utmParams.utm_content || '',
                "ecommerce": {
                    "creative_name": product.querySelector('img').src.substring(product.querySelector('img').src.lastIndexOf('/') + 1) || '',
                    "creative_slot": this.getCreativeSlot(product),
                    "promotion_id": "N/A",
                    "promotion_name": promotionName,
                    "items": [
                        item
                    ],
                },
                "gtm.uniqueEventId": 1
            })
        }
    }

    trackPromoImpression(product) {
        if (product.dataset.eec) {
            const item = this.prepareItem(product);

            let promotionName = window.promotionName;
            let utmParams = getAllUrlParams();

            const heading = product.querySelector('.heading-1, .heading-2, .heading-3, .heading-4');
            if (heading) {
                promotionName = 'Club - ' + window.tcsCampaign + ' - ' + heading.innerText;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "view_promotion",
                'campaignSource': utmParams.utm_source || '',
                'campaignMedium': utmParams.utm_medium || '',
                'campaignName': utmParams.utm_campaign || '',
                'campaignTerm': utmParams.utm_term || '',
                'campaignContent': utmParams.utm_content || '',
                "ecommerce": {
                    "creative_name": product.querySelector('img').src.substring(product.querySelector('img').src.lastIndexOf('/') + 1) || '',
                    "creative_slot": this.getCreativeSlot(product),
                    "promotion_id": "N/A",
                    "promotion_name": promotionName,
                    "items": [
                        item
                    ],
                },
                "gtm.uniqueEventId": 1
            })
        }
    }

    trackItemList(products) {
        let items = [];

        products.forEach((product, index) => {
            if (product.dataset.eec) {
                const item = this.prepareItem(product);

                item.index = index + 1;

                items.push(item);
            }
        })

        items = items.filter((value, index, self) => self.findIndex( next => ( next.price === value.price)) === index);

        let utmParams = getAllUrlParams();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "view_item_list",
            'campaignSource': utmParams.utm_source || '',
            'campaignMedium': utmParams.utm_medium || '',
            'campaignName': utmParams.utm_campaign || '',
            'campaignTerm': utmParams.utm_term || '',
            'campaignContent': utmParams.utm_content || '',
            "ecommerce": {
                "items": items,
                "item_list_id": "membership_product_list",
                "item_list_name": "membership product list"
            },
            "gtm.uniqueEventId": 1
        })
    }

    handleFilter(event) {
        const button = event.target;
        const container =  button.parentElement;
        const section = button.closest('section');

        container.querySelectorAll('.button').forEach(button => {
            if (section.contains(button)) {
                button.classList.add('is-white');
                button.classList.remove('is-primary');
            }
        })

        button.classList.add('is-primary');
        button.classList.remove('is-white');
        this.updateFilters(section);
    }

    updateFilters(section) {
        let filters = {};

        this.hiddenProducts[section] = this.hiddenProducts[section] || [];

        this.filterList.forEach(button => {
            if (section.contains(button)) {
                if (button.classList.contains('is-primary')) {
                    filters[button.dataset.filterKey] = button.dataset.filterValue;
                }
            }
        })

        // this.products.forEach(product => {
        //     if (section.contains(product)) {
        //         product.parentElement.parentElement.classList.add('is-hidden');
        //     }
        // })

        let selector = '';
        for (const [key, value] of Object.entries(filters)) {
            selector += '[data-ecommerce-' + key.toLowerCase() + '="' + value.toLowerCase() +'"]';
        }

        section.querySelectorAll('[data-ecommerce]').forEach(element => {
            const hiddenProduct = element.parentElement.parentElement;

            if (!element.matches(selector)) {
                if (!hiddenProduct.classList.contains('swiper-slide')) {
                    hiddenProduct.classList.add('is-hidden');
                }
            }
        })

        if (this.hiddenProducts[section].length === 0) {
            section.querySelectorAll('[data-ecommerce]').forEach(element => {
                const hiddenProduct = element.parentElement.parentElement;

                if (hiddenProduct.classList.contains('swiper-slide')) {
                    this.hiddenProducts[section].push(hiddenProduct);
                    hiddenProduct.remove();
                }
            })
        }

        const sliderContainer = section.querySelector('.js-slider');

        if (sliderContainer && sliderContainer.swiper) {
            sliderContainer.querySelector('.swiper-wrapper').innerHTML = '';
        }

        this.hiddenProducts[section].forEach((product) => {
            if (product.querySelector(selector)) {
                section.querySelector('.swiper-wrapper').appendChild(product);
            }
        })

        if (sliderContainer && sliderContainer.swiper) {
            initSliders();
        }

        section.querySelectorAll(selector).forEach(element => {
            const hiddenProduct = element.parentElement.parentElement;

            if (!hiddenProduct.classList.contains('swiper-slide')) {
                element.parentElement.parentElement.classList.remove('is-hidden');
            }
        })
    }

    updateButtonLinks() {
        this.buttonList.forEach(button => {
            if (!button.classList.contains('js-skip-url')) {
                const productContainer = button.closest('[data-ecommerce]');
                const legacy = productContainer.dataset.ecommerceLegacy;
                let href;

                if (legacy === '0') {
                    const newMember = productContainer.dataset.ecommerceNewmember === '1' ? '1' : '0';
                    const isYouth =  productContainer.dataset.ecommerceIsyouth;
                    const isVrs =  productContainer.dataset.ecommerceIsvrs;
                    const isEndorsement =  productContainer.dataset.ecommerceIsendorsement;
                    const campaignId = productContainer.dataset.ecommerceCampaign;
                    const shopPath = productContainer.dataset['ecommerceShoppath' + document.documentElement.lang];

                    if (document.location.host !== 'club.tcs.ch' && document.location.host !== 'club-tcs.nfxhosting.de') {
                        href = 'https://uatweb1.tcs.ch/' + document.documentElement.lang + '/shop/' + shopPath + '?campaigns=' + campaignId;
                    } else {
                        href = 'https://www.tcs.ch/' + document.documentElement.lang + '/shop/' + shopPath + '?campaigns=' + campaignId;
                    }

                    if (isYouth === '1') {
                        href += '&youth=1';
                    }

                    if (newMember === '0') {
                        href += '&member=1';
                    }

                    if (isVrs === '1') {
                        // href += '&vrs=1';
                    }

                    if (isEndorsement === '1') {
                        href += '&endorsement=1';
                    }

                    button.setAttribute('href', href);

                }
            }
        })
    }
}

export default new EcommerceForm();
